import { Icon } from 'semantic-ui-react';
import styled from 'styled-components';

export const SuccessCheckmark = styled(Icon)`
  &.icon {
    color: var(--color-pure-white);
    border-radius: 100%;
    background: var(--color-success);
    font-size: 0.6rem;
    width: 1rem;
    height: 1rem;
    line-height: 1rem;
    margin: 0;
    width: 1rem;
    height: 1rem;
  }
`;
SuccessCheckmark.defaultProps = {
  name: 'check'
};

export const TabContent = styled.div`
  display: flex;
  align-items: center;
  padding-right: var(--small);
  .ui.circular.label {
    margin-left: auto;
    + .ui.circular.label {
      margin-left: var(--x-small);
    }
  }
  .complete-checkmark {
    margin-left: auto;
  }
`;

export const ProgressBarContainer = styled.div`
  padding: var(--medium) var(--medium) var(--x-large) 0;
`;

export const SubjectHeader = styled.button<{ active?: boolean }>`
  all: unset;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: var(--2x-small);
  width: 100%;
  padding: var(--small) var(--small) var(--small) 0.3125rem;
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
  cursor: pointer;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: -2px;
    width: 2px;
    height: 100%;
    background: transparent;
    transition: 0.3s ease-in-out;
  }
  ${({ active }) => active && `
    background: var(--color-primary-light);
    &::after {
      background: var(--color-pure-black);
      z-index: 1;
    }
  `}
  &:hover:not(:disabled)::after {
    background: var(--color-charcoal);
  }
`;

export const TwirlIcon = styled(Icon)<{ expanded?: boolean }>`
  &.icon {
    margin: 0;
    margin-top: -4px;
    display: inline-block;
    transform-origin: 50% 50%;
    transition: transform 0.2s ease;
    transform: rotate(${({ expanded }) => (expanded ? '90deg' : '0deg')});
    color: var(--color-charcoal);
  }
`;
TwirlIcon.defaultProps = { name: 'caret right' as any };

export const SubjectChildren = styled.div`
  padding-left: var(--small);
`;